import LinkExtension from '@tiptap/extension-link';
import BubbleMenu from '@tiptap/extension-bubble-menu';
import { buildHtmlElement } from '@/js/util/build_html_element';
import { menuControlFor } from './_get_menu_control';

const syncMenu = ({ editor }) => {
  const control = menuControlFor(editor, 'link:set');
  const controlIsActive = editor.isActive('link');

  control?.classList?.toggle('active', controlIsActive);
};

const linkConfig = {
  openOnClick: false,
  autoLink: true,
  HTMLAttributes: {
    target: '_blank',
  },
};

const linksMenuConfig = {
  pluginKey: 'linksContextualMenu',
  shouldShow: ({ editor }) => editor.isActive('link'),
  element: buildHtmlElement('links-contextual-menu'),
  tippyOptions: {
    zIndex: 1,
    placement: 'right',
    theme: 'df-editor',
    onShow: (instance) => instance.setContent(buildHtmlElement('links-contextual-menu')),
  },
};

const Link = LinkExtension.extend({
  onSelectionUpdate: syncMenu,
  onTransaction: syncMenu,
});

const LinksMenu = BubbleMenu.extend({ name: 'LinksMenu' });

export default [Link.configure(linkConfig), LinksMenu.configure(linksMenuConfig)];
